export const ToggleServicesNav = (function () {
	'use strict';

	let toggleNav = document.querySelector('.toggle-nav-services');

	function init() {
		if (!toggleNav) {
			return;
		}
		toggleServicesNav();
	}

	function toggleServicesNav() {
		var menuServices = document.querySelector('.menu-services');
		var serviceLinks = menuServices.querySelectorAll('li > a');
		var toggleServices = document.querySelector('.toggle-nav-services');

		toggleServices.addEventListener('click', function () {
			this.classList.toggle('open');
			menuServices.classList.toggle('expanded');
		});

		serviceLinks.forEach(function (link) {
			link.addEventListener('click', function () {
				menuServices.classList.remove('expanded');
				toggleServices.classList.remove('open');
			});
		});
	}

	return {
		init: init,
	};
})();
